import { render, staticRenderFns } from "./blog-menu-item.vue?vue&type=template&id=444264ee&scoped=true"
import script from "./blog-menu-item.vue?vue&type=script&lang=js"
export * from "./blog-menu-item.vue?vue&type=script&lang=js"
import style0 from "./blog-menu-item.vue?vue&type=style&index=0&id=444264ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444264ee",
  null
  
)

export default component.exports